import langRu from 'quasar/lang/ru';

import Quasar, {
  QLayout,
  QPageContainer,
  QPage,
  QHeader,
  QDrawer,
  QPageSticky,
  QPageScroller,
  QTooltip,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QAvatar,
  QItemSection,
  QItem,
  QIcon,
  QSeparator,
  QList,
  QForm,
  QInput,
  QSelect,
  QItemLabel,
  QPopupProxy,
  QDate,
  QTime,
  QCard,
  QCardSection,
  QExpansionItem,
  QTable,
  QTr,
  QTh,
  QTd,
  QCheckbox,
  QMarkupTable,
  QSpinner,
  QInnerLoading,
  QRadio,
  QDialog,
  QCardActions,
  QUploader,
  QSpace,
  QBreadcrumbs,
  QBreadcrumbsEl,
  QOptionGroup,
  QScrollArea,
  QSpinnerHourglass,
  QSpinnerDots,
  QToggle,
  QBtnToggle,
  QTree,
  QBtnDropdown,
  QSkeleton,
  QImg,
  QMenu,
  QField,
  QTab,
  QTabs,
  QStepper,
  QStep,
  QChip,
  QBanner,
  QChatMessage,
} from 'quasar';

import QDateInput from 'RootDir/shared_components/QDateInput.vue';

export default (Vue) => {
  Vue.use(Quasar, {
    lang: langRu,
    components: {
      QLayout,
      QPageContainer,
      QPage,
      QHeader,
      QDrawer,
      QPageSticky,
      QPageScroller,
      QToolbar,
      QToolbarTitle,
      QTooltip,
      QBtn,
      QAvatar,
      QItemSection,
      QItem,
      QIcon,
      QSeparator,
      QList,
      QForm,
      QInput,
      QSelect,
      QItemLabel,
      QPopupProxy,
      QDate,
      QTime,
      QCard,
      QCardSection,
      QExpansionItem,
      QTable,
      QTr,
      QTh,
      QTd,
      QCheckbox,
      QMarkupTable,
      QSpinner,
      QInnerLoading,
      QRadio,
      QDialog,
      QCardActions,
      QSpace,
      QUploader,
      QBreadcrumbs,
      QBreadcrumbsEl,
      QOptionGroup,
      QScrollArea,
      QSpinnerHourglass,
      QSpinnerDots,
      QToggle,
      QBtnToggle,
      QTree,
      QBtnDropdown,
      QSkeleton,
      QImg,
      QMenu,
      QField,
      QDateInput,
      QTab,
      QTabs,
      QStepper,
      QStep,
      QChip,
      QBanner,
      QChatMessage,
    },
  });
};
